{
  "time_range_error_message": "La hora de finalización debe ser posterior a la hora de inicio",
  "attribute_list_items": "elementos de la lista de atributos",
  "attribute_list_item": "elemento de la lista de atributos",
  "attribute_list_item_order": "orden de elementos de la lista de atributos"
}